import { track } from "../track";

export const trackGenContentTry = (params: {
  use_case: string;
  archetype: string;
  arch_prompt?: string;
  background: string;
  bg_prompt?: string;
  style: string;
  pacing: string;
  subtitles: boolean;
  content_source: "script" | "tiktok";
  script_text?: string;
  tiktok_url?: string;
}) => {
  const eventSource = {
    script: "script",
    tiktok: "tiktok_url",
  }[params.content_source];

  track({ event: "gen_content_try", ...params, content_source: eventSource });
};
